export default "https://cdn-static.gokick.com/assets/31d35e8a0a5d253fd42fea745a10067c9b91f7ab/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";